module.exports = __webpack_public_path__ + "img/stena08.1a319c91.jpg";